import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";

export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
